
function parseQuery(qstr){
  const query = {};
  if (qstr.length < 2) {
    return null;
  }
  const params = qstr.substr(1).split('&');
  for (let i = 0; i < params.length; i++) {
    const parts = params[i].split('=');
    const key = parts.shift();
    query[decodeURIComponent(key)] = decodeURIComponent(parts.join('=') || '');
  }
  return query;
}

class LandingpageController {
  constructor($state,$window,storage,billingService, $rootScope,$filter,$timeout,navigationManager,$scope, laboxSSapi, analyticsService) {
    this.name = 'landingpage';
    this.state = $state;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$scope = $scope;
    //keep content hidden until get data from backend.
    this.landingPageLoader = true;
    this.$rootScope.analytics = {
      "omniturePath": $window.location.protocol +'//' +$window.location.hostname +':' +$window.location.port,
    };

    $scope.pageName = null;
    $scope.event = 'event1';
    $scope.billingStatus = this.$rootScope.omnitureBillingStatus || null;
    $scope.paperlessbill = this.$rootScope.omniturePaperlessbill || null;
    $scope.omnitureLinkUrl = null;

    //customer cable-vision and suddenlink
    this.isCablevision = false;
    this.isSuddenlink = false;
    this.hasSuddenlinkId = true;
    this.menuitems = [];

    //bp-global parameters
    this.bpGlobalInfo = null;
    this.amountTestDue = 0;
    this.isPPVProd = false;
    this.PPVInhibitBalance = 0;
    this.PPVInhibit = false
    this.amountDueDate = '';
    this.creditBalance = false;
    this.creditAmount = 0;
    this.noPaymentDuewithAccBalance=false;
    this.noPaymentDue = false;
    this.hasOptimumId=false;
    this.currentAccount = null;
    this.items = [];
    this.deAuthInfo = null;
    this.errorPay = false;
    this.isPreDAuthTwo = false;
    this.isPreDAuthOne = false;
    this.paymentAlertMsg= '';
    this.genericAlertMsg= '';
    this.isPastDue=false;
    this.paymentDue = false;
    this.displayAlertModal = false;
    this.displayGenericAlertModal = false;

    this.enrollSuccess = false;
    this.fromOptIdsPage = false;
    this.fromPaperlessPage = false;
    this.working_link = '';

    //alert popup
    this.alertMsgTwo = null;

    var accNum;

    navigationManager.registerViewComponent(this, $scope, 'home.landingpage');

    this.enrollSuccess = this.$rootScope.enrollValue;
    this.fromOptIdsPage = this.$rootScope.fromOptimumIdPage;
    this.fromSdlIdsPage = this.$rootScope.fromSdlIdsPage
    this.fromPaperlessPage = this.$rootScope.fromPaperlessBillingPage;
    this.fromTutorialPage = this.$rootScope.fromTutorialPage;
    this.fromVideoBillPage = this.$rootScope.fromVideoBillPage;
    this.fromFaqPage = this.$rootScope.fromFaqPage;

    //setting up global parameter for app.
    this.$onInit = function () {
      this.$rootScope.myAccount = true;

      // omniture for first load when no option or when coming back from any of the page
      console.log('!! omniture for first load when no option or when coming back from any of the page !!');
      // var queryParams = parseQuery($window.location.search);
      // if(queryParams.option === null) {
        switch (true) {
          case this.viewpaybillPage:
            $scope.pageName = 'mybill';
            $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding';
            break;
          case this.fromPaperlessPage:
            $scope.pageName = 'paperless billing';
            $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/paperlessbillinglanding';
            break;
          case this.fromOptIdsPage:
            $scope.pageName = 'ids';
            $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/optimumidslanding';
            break;
          case this.fromTutorialPage:
            $scope.pageName = 'tutorial';
            $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/tutorialslanding';
            break;
          case this.fromFaqPage:
            $scope.pageName = 'quick tips';
            $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/faqlanding';
            break;
          default:
            $scope.pageName = 'my account';
            $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding';
        }
        console.log('omniture page is : ' +$scope.pageName);
        this.$timeout(() => {
          this.$rootScope.omnitureBillingStatus = $scope.billingStatus;
          this.$rootScope.omniturePaperlessbill = $scope.paperlessbill;
        }, 5000);
    };

    this.$onDestroy = function () {
      this.$rootScope.myAccount = false;
    };

    $scope.$watch ('[pageName, event, billingStatus, paperlessbill]', function (newValue, oldValue) {
      console.log('!! omniture watch variables ' +'pagename : ' +$scope.pageName +'event : ' +$scope.event
        +'billingStatus : ' +$scope.billingStatus +'paperlessbill : ' +$scope.paperlessbill);
      if($scope.pageName && $scope.billingStatus && ($scope.paperlessbill !== null)) {
        console.log('!! omniture watch inside if');
        // $rootScope.omnitureBillingStatus = $scope.billingStatus;
        // $rootScope.omniturePaperlessbill = $scope.paperlessbill;
        analyticsService.sendReport('home', $scope.pageName, $scope.event, null, null, null, null, $scope.omnitureLinkUrl,
          $scope.billingStatus, $scope.paperlessbill, $scope.pageUrl);
      }
    });
    var queryParams = parseQuery($window.location.search);
    if(queryParams) {
      storage.setItem('session', 'home_id', queryParams.home_id);
      storage.setItem('session', 'plant_id', queryParams.plant_id);
      storage.setItem('session', 'casn', queryParams.casn);
      storage.setItem('session', 'option', queryParams.option);
      storage.setItem('session', 'showFaqTutorials', queryParams.showFaqTutorials);
      // this.$rootScope.analytics.balance === null ? this.$rootScope.analytics.balance = 'cur' : this.$rootScope.analytics.balance = this.$rootScope.analytics.balance;

      if(queryParams.option === "quicktips") {
        // omniture for first load when load on quicktips
        console.log('!!omniture for first load when quick tips!!');
        $scope.pageName = 'quick tips';
        $scope.event = 'event1';
        this.fromFaqPage = true;
      } else if(queryParams.option === "tutorials") {
        // omniture for first load when load on tutorials
        console.log('!!omniture for first load when tutorials!!');
        $scope.pageName = 'tutorial';
        $scope.event = 'event1';
        this.fromTutorialPage = true;
      } else if(queryParams.option === "ids") {
        // omniture for first load when load on ids
        console.log('!!omniture for first load when ids!!');
        $scope.pageName = 'ids';
        $scope.event = 'event1';
        this.fromOptIdsPage = true;
      } else if(queryParams.option === "paperlessbilling") {
        // omniture for first load when load on mybill or myaccount
        console.log('!!omniture for first load when paperless billing!!');
        $scope.pageName = 'paperless billing';
        $scope.event = 'event1';
        this.fromPaperlessPage = true;
      } else if(queryParams.option === "myAccount" || queryParams.option === "mybill") {
        // omniture for first load when load on mybill or myaccount
        console.log('!!omniture for first load when mybill or myaccount!!');
        $scope.pageName = 'my account';
        $scope.event ='event1';
        this.viewpaybillPage = true;
      }
    }

    if(this.$rootScope.previousState === 'home.paperlessbilling'){
      console.log("my previous state is:",this.$rootScope.previousState);
    }

    if (this.enrollSuccess) {
      if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
            this.isCablevision = true;
            this.$rootScope.isCablevision = this.isCablevision;
            // omniture if already enrolled in paperlessbill
            $scope.paperlessbill = true;
            console.log('!! omniture setting paperless true from enroll success!!');
            console.log('showFaqTutorials: ', + storage.getItem('session', 'showFaqTutorials'));

            if(storage.getItem('session', 'showFaqTutorials') && storage.getItem('session', 'showFaqTutorials') === "1") {
              this.menuitems = [{
                  label: 'View & Pay My Bill',
                  state: 'home.landingpage.viewpaybilllanding'
              },
              {
                  label: 'Paperless Billing',
                  state: 'home.landingpage.paperlessbillinglanding'
              }, {
                  label: 'Optimum IDs',
                  state: 'home.landingpage.optimumidslanding'
              }, {
                  label: 'Tutorials',
                  state: 'home.landingpage.tutorialslanding'
              }, {
                  label: 'Quick Tips',
                  state: 'home.landingpage.faqlanding'
              }];
            } else {
              $scope.pageName = 'my account';
              $scope.event ='event1';
              this.viewpaybillPage = true;
              this.fromFaqPage = false;

              this.menuitems = [{
                  label: 'View & Pay My Bill',
                  state: 'home.landingpage.viewpaybilllanding'
              },
              {
                  label: 'Paperless Billing',
                  state: 'home.landingpage.paperlessbillinglanding'
              }, {
                  label: 'Optimum IDs',
                  state: 'home.landingpage.optimumidslanding'
              }];
            }
            if (storage.getItem('session', 'accno')) {
                accNum = storage.getItem('session', 'accno');
                accNum = accNum.slice(0, 5) + "-" + accNum.slice(5, 11) + "-" + accNum.slice(11, 13);
                this.account_number = accNum;
            }

            if (storage.getItem('session', 'casn')) {
              var casnNum, casnNum1, i, tempVar="", j;
              casnNum = storage.getItem('session', 'casn');
              casnNum1 = storage.getItem('session', 'casn');
              console.log("Casn 1 is:", casnNum1.length);
              for(i=0; i<casnNum1.length; i++) {
                j = i+2;
                if(i === casnNum1.length-2 || i === casnNum1.length-1) {
                  tempVar = tempVar + casnNum1.slice(i,j);
                } else {
                  tempVar = tempVar + casnNum1.slice(i,j) + ":";
                }
                i = i+1;
              }
              casnNum1 = tempVar;
              this.serial_number = casnNum;
              console.log("this.serial_number:", this.serial_number);
            }

            console.log("menu items Cablevision:", this.menuitems);
            this.landingPageLoader = false;
            setTimeout(function() {
                /*document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';*/
                document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
                document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
                /*document.getElementById('landingBg').style.marginTop = '0vh';*/
            }, 1000);

            this.focus('navigation_btn1');
            this.$rootScope.enrollValue = false;
        }
    } else {
        //based on plant id will determine customer.
        if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
          //cablevision customer
            this.isCablevision = true;
            this.$rootScope.isCablevision = this.isCablevision;
            setTimeout(function () {
              if($scope.paperlessbill === null) {
                //omniture if not enrolled in paperlessbill
                $scope.paperlessbill = false;
                console.log('!! omniture setting paperless false from enroll success else!!');
              }
            }, 3000);

            console.log('showFaqTutorials: ', + storage.getItem('session', 'showFaqTutorials'));
            var showFaqTutorialsVal = storage.getItem('session', 'showFaqTutorials');

            if(showFaqTutorialsVal && (showFaqTutorialsVal === "1")) {
              console.log('i am coming here');
              this.menuitems = [{
                  label: 'View & Pay My Bill',
                  state: 'home.landingpage.viewpaybilllanding'
              },
              {
                  label: 'Paperless Billing',
                  state: 'home.landingpage.paperlessbillinglanding'
              }, {
                  label: 'Optimum IDs',
                  state: 'home.landingpage.optimumidslanding'
              }, {
                  label: 'Tutorials',
                  state: 'home.landingpage.tutorialslanding'
              }, {
                  label: 'Quick Tips',
                  state: 'home.landingpage.faqlanding'
              }];
            } else {
              console.log('actually i am coming here');
              $scope.pageName = 'my account';
              $scope.event ='event1';
              this.viewpaybillPage = true;
              this.fromFaqPage = false;

              this.menuitems = [{
                  label: 'View & Pay My Bill',
                  state: 'home.landingpage.viewpaybilllanding'
              },
              {
                  label: 'Paperless Billing',
                  state: 'home.landingpage.paperlessbillinglanding'
              }, {
                  label: 'Optimum IDs',
                  state: 'home.landingpage.optimumidslanding'
              }];
            }

            console.log("menu items Cablevision:", this.menuitems);
            if (storage.getItem('session', 'casn')) {
              var casnNum, casnNum1, i, tempVar="", j;
              casnNum = storage.getItem('session', 'casn');
              casnNum1 = storage.getItem('session', 'casn');
              console.log("Casn 1 is:", casnNum1.length);
              for(i=0; i<casnNum1.length; i++) {
                j = i+2;
                if(i === casnNum1.length-2  || i === casnNum1.length-1) {
                  tempVar = tempVar + casnNum1.slice(i,j);
                } else {
                  tempVar = tempVar + casnNum1.slice(i,j) + ":";
                }
                i = i+1;
              }
              casnNum1 = tempVar;
              this.serial_number = casnNum;
              console.log("this.serial_number from 1st block:", this.serial_number);
            }

            //getting bp global data for
            billingService.getBpGlobalData().then((res) => {
                console.log('this is bp global information from landing page.--> ', res);
                if (res && res.data && res.data.status && res.data.status.statusCode === "00000") {
                    console.log("view bpGlobalInfo on landing page: ", res.data);
                    if (storage.getItem('session', 'accno')) {
                        accNum = storage.getItem('session', 'accno');
                        accNum = accNum.slice(0, 5) + "-" + accNum.slice(5, 11) + "-" + accNum.slice(11, 13);
                        this.account_number = accNum;
                        console.log("Account Number is:", this.account_number);
                    }
                    this.bpGlobalInfo = res.data;
                    this.amountTestDue = res.data.amountDue;
                    this.PPVInhibitBalance = res.data.billPayCache.ppvinhibitBalance;
                    console.log("this.PPVInhibitBalance is " + this.PPVInhibitBalance);
                    console.log("this.bpGlobalInfo.currentBalance is " + this.bpGlobalInfo.currentBalance);
                    console.log("this.bpGlobalInfo.amountDue is " + this.bpGlobalInfo.amountDue);

                    if (this.bpGlobalInfo.dueDate !== null) {
                        var myDate = this.bpGlobalInfo.dueDate;
                        const parts = myDate.split('/');
                        myDate = parts[0] + '/' + parts[1];
                        this.amountDueDate = myDate;
                    }
                    // checking amount due in different phases
                    //cur
                    if (this.bpGlobalInfo.currentBalance < 0) {
                        // omniture I have current balance < 0 my state is current
                        console.log('!! omniture I have current balance < 0 my state is current !!');
                        // this.$rootScope.analytics.balance = 'cur';
                        $scope.billingStatus = 'cur';
                        this.creditBalance = true;
                        this.creditAmount = (this.bpGlobalInfo.currentBalance * -1);

                        /**************************************************************/
                        /*   This is to be run to change the paperless billing        */
                        /**************************************************************/
                        billingService.getCurrectAcc().then((resp) => {
                            console.log("resp of current account on landing page.:", resp);
                            if (resp && resp.email && resp.isPaperBill === "false") {
                                this.menuitems[1].label = "Paperless Billing";
                                $scope.paperlessbill = true;
                                console.log('!! omniture setting paperless true from billing service call 1!!');
                            }
                        });
                        this.landingPageLoader = false;
                        if(this.fromOptIdsPage){
                            this.focus('navigation_btn2');
                            this.$rootScope.fromOptimumIdPage = false;

                        } else if(this.fromPaperlessPage){
                            this.focus('navigation_btn1');
                            this.$rootScope.fromPaperlessBillingPage = false;
                        }
                        // else if(this.fromVideoBillPage){
                        //     this.focus('navigation_btn1');
                        //     this.$rootScope.fromVideoBillPage = false;
                        // }
                        else if(this.fromTutorialPage){
                          this.focus('navigation_btn3');
                          this.$rootScope.fromTutorialPage = false;
                        } else if(this.fromFaqPage){
                          this.focus('navigation_btn4');
                          this.$rootScope.fromFaqPage = false;
                        } else {
                            this.focus('navigation_btn0');
                        }
                    }
                    //cur
                    else if (this.bpGlobalInfo.amountDue <= 0) {
                      // omniture I have amount due zero and current balance > 0 my state is current
                      console.log('!! omniture I have amount due zero and current balance > 0 my state is current !!');
                      $scope.billingStatus = 'cur';

                      if(this.bpGlobalInfo.currentBalance > 0) {
                        this.noPaymentDuewithAccBalance = true;
                      } else {
                        this.noPaymentDue = true;
                      }
                        /**************************************************************/
                        /*This is to be run to change the paperless billing menu item */
                        /**************************************************************/
                        billingService.getCurrectAcc().then((resp) => {
                            console.log("resp of current account on landing page.:", resp);
                            if (resp && resp.email && resp.isPaperBill === "false") {
                                this.menuitems[1].label = "Paperless Billing";
                                $scope.paperlessbill = true;
                                console.log('!! omniture setting paperless true from billing service call 2!!');
                            }
                        });
                        this.landingPageLoader = false;
                        if(this.fromOptIdsPage){
                            this.focus('navigation_btn2');
                            this.$rootScope.fromOptimumIdPage = false;

                        }
                        // else if(this.fromVideoBillPage){
                        //     this.focus('navigation_btn1');
                        //     this.$rootScope.fromVideoBillPage = false;
                        // }
                        else if(this.fromPaperlessPage){
                            this.focus('navigation_btn1');
                            this.$rootScope.fromPaperlessBillingPage = false;
                        } else if(this.fromTutorialPage){
                          this.focus('navigation_btn3');
                          this.$rootScope.fromTutorialPage = false;
                        } else if(this.fromFaqPage){
                          this.focus('navigation_btn4');
                          this.$rootScope.fromFaqPage = false;
                        } else {
                            this.focus('navigation_btn0');
                        }
                        //this.focus('navigation_btn0');
                    }
                    //pastdue or deauth
                    else if (this.bpGlobalInfo.amountDue > 0) {

                        //verifying from where bp global coming
                        if (storage.getItem('session', 'hasOptimumId')) {
                            this.hasOptimumId = true;
                        }
                        // first we will get list of cards by getCurracc
                        billingService.getCurrectAcc().then((resp) => {
                            console.log("resp of current account on landing page.:", resp);
                            if (resp && resp.email && resp.isPaperBill === "false") {
                                this.menuitems[1].label = "Paperless Billing";
                                $scope.paperlessbill = true;
                                console.log('!! omniture setting paperless true from another billing service call 4!!');
                            }
                            if (resp && resp.paymentMethods) {
                                console.log("This is Currect Account ebillInformationOutputs from landing page.---> ", resp.paymentMethods);
                                this.currentAccount = resp;
                                this.items = resp.paymentMethods;
                                console.log("this.items in landing page:", this.items);
                            } else {
                                this.items = [];
                                console.log("this.items in landing page:", this.items);
                            }
                        }).then(() => {
                            //this block plays pre-de auth one or two
                            // deauth
                            if (this.bpGlobalInfo.billPayCache && this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0) {
                              this.deAuthInfo = billingService.deauthInfo(this.bpGlobalInfo.billPayCache);
                                //here we know we have deauth so now determining one or two so set text for alert and other msg.
                                this.errorPay = true;
                                document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
                                document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
                                /*document.getElementById('landingBg').style.marginTop = '0vh';*/
                                if (this.deAuthInfo.isDeauthTwo) {
                                  // omniture I have amount due > zero my state is deauth2
                                  console.log('!! omniture I have amount due > zero my state is deauth2 !!');
                                  // this.$rootScope.analytics.balance = 'deauth2';
                                  $scope.pageName = 'deauth2';
                                  $scope.event = 'event1';
                                  $scope.billingStatus = 'deauth2';
                                  $scope.popup = true;
                                  this.isPreDAuthTwo = true;
                                    this.paymentAlertMsg = 'Your account is past due. Make a payment now to avoid service interruptions.';
                                    this.alertMsgTwo = 'Please pay ' + $filter('currency')(this.bpGlobalInfo.amountDue, '$', 2) + ' immediately to keep your service & avoid late or restore service fees.';
                                }
                                else if (this.deAuthInfo.isDeauthOne) {
                                  // omniture I have amount due > zero my state is deauth1
                                  console.log('!! omniture I have amount due > zero my state is deauth1 !!');
                                  // this.$rootScope.analytics.balance = 'deauth1';
                                  $scope.pageName = 'deauth1';
                                  $scope.event = 'event1';
                                  $scope.billingStatus = 'deauth1';
                                  $scope.popup = true;

                                  this.isPreDAuthOne = true;
                                    this.paymentAlertMsg = 'Your account is past due. Please make a payment by ' + this.deAuthInfo.startDate + ' to avoid late fees or service interruptions.';
                                    this.alertMsgTwo = 'Please pay ' + $filter('currency')(this.bpGlobalInfo.amountDue, '$', 2) + ' by ' + this.deAuthInfo.startDate + ' to keep your service & avoid late or restore service fees.';
                                }
                                // else if (this.PPVInhibitBalance > 0) {
                                //     this.PPVInhibit = true;
                                // }
                                this.landingPageLoader = false;
                                //code for alert
                                if (storage.getItem('session', 'showLandingPopup')) {
                                    console.log('Coming here');
                                        //this.displayAlertModal = false;
                                    //this.focus('navigation_btn0');
                                    if(this.fromOptIdsPage){
                                        this.focus('navigation_btn2');
                                        this.$rootScope.fromOptimumIdPage = false;

                                    } else if(this.fromPaperlessPage){
                                        this.focus('navigation_btn1');
                                        this.$rootScope.fromPaperlessBillingPage = false;
                                    }
                                    // else if(this.fromVideoBillPage){
                                    //     this.focus('navigation_btn2');
                                    //     this.$rootScope.fromVideoBillPage = false;
                                    // }
                                    else if(this.fromTutorialPage){
                                      this.focus('navigation_btn3');
                                      this.$rootScope.fromTutorialPage = false;
                                    } else if(this.fromFaqPage){
                                      this.focus('navigation_btn4');
                                      this.$rootScope.fromFaqPage = false;
                                    } else {
                                        this.focus('navigation_btn0');
                                    }
                                } else {
                                    console.log('!!omniture deauth popup is here!!');
                                    storage.setItem('session', 'showLandingPopup', true);
                                    this.displayAlertModal = true;
                                    this.focusItem('confirm-btn');

                                    setTimeout(function() {
                                        //navigation setup
                                        navigationManager.registerNavigate('confirm-btn', 'down');
                                        navigationManager.registerNavigate('confirm-btn', 'left', 'cancel-btn');
                                        navigationManager.registerNavigate('confirm-btn', 'up');
                                        navigationManager.registerNavigate('confirm-btn', 'right');
                                        navigationManager.registerNavigate('cancel-btn', 'down');
                                        navigationManager.registerNavigate('cancel-btn', 'right', 'confirm-btn');
                                        navigationManager.registerNavigate('cancel-btn', 'up');
                                        navigationManager.registerNavigate('cancel-btn', 'left');
                                        //end navigation setup
                                    }, 1000);
                                }

                            }
                            ///this block plays pastdue stuff
                            //pastdue
                            else if (this.bpGlobalInfo.pastDueAmount > 0) {
                              // omniture I have amount due > zero my state is pastdue
                              console.log('!! omniture I have amount due > zero my state is pastdue !!');
                              $scope.billingStatus = this.bpGlobalInfo.pastDue;
                              console.log('!! omniture balance : ' +$scope.billingStatus);
                              this.errorPay = true;
                                this.paymentAlertMsg = 'Your account is past due. Please make a payment to avoid late fees or service interruptions.';
                                document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
                                document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
                                /*document.getElementById('landingBg').style.marginTop = '0vh';*/
                                this.isPastDue = true;
                                this.landingPageLoader = false;
                                //this.focus('navigation_btn0');
                                if(this.fromOptIdsPage){
                                    this.focus('navigation_btn2');
                                    this.$rootScope.fromOptimumIdPage = false;

                                } else if(this.fromPaperlessPage){
                                    this.focus('navigation_btn1');
                                    this.$rootScope.fromPaperlessBillingPage = false;
                                }
                                // else if(this.fromVideoBillPage){
                                //     this.focus('navigation_btn1');
                                //     this.$rootScope.fromVideoBillPage = false;
                                // }
                                else if(this.fromTutorialPage){
                                  this.focus('navigation_btn3');
                                  this.$rootScope.fromTutorialPage = false;
                                } else if(this.fromFaqPage){
                                  this.focus('navigation_btn4');
                                  this.$rootScope.fromFaqPage = false;
                                } else {
                                    this.focus('navigation_btn0');
                                }
                            } else if (this.PPVInhibitBalance != null && this.PPVInhibitBalance > 0 && this.isPPVProd) {
                                this.PPVInhibit = true;
                                this.landingPageLoader = false;
                                if(this.fromOptIdsPage){
                                    this.focus('navigation_btn2');
                                    this.$rootScope.fromOptimumIdPage = false;

                                } else if(this.fromPaperlessPage){
                                    this.focus('navigation_btn1');
                                    this.$rootScope.fromPaperlessBillingPage = false;
                                }
                                // else if(this.fromVideoBillPage){
                                //     this.focus('navigation_btn1');
                                //     this.$rootScope.fromVideoBillPage = false;
                                // }
                                else if(this.fromTutorialPage){
                                  this.focus('navigation_btn3');
                                  this.$rootScope.fromTutorialPage = false;
                                } else if(this.fromFaqPage){
                                  this.focus('navigation_btn4');
                                  this.$rootScope.fromFaqPage = false;
                                } else {
                                    this.focus('navigation_btn0');
                                }
                                //this.focus('navigation_btn0');
                            }
                            //if nothings remain and only amount due
                            // if none of above it is current state
                            else {
                              // omniture I have amount due = zero my state is current
                              console.log('!! omniture I have amount due = zero my state is current !!');
                              $scope.billingStatus = 'cur';

                              this.paymentDue = true;
                                this.landingPageLoader = false;
                                if(this.fromOptIdsPage){
                                    this.focus('navigation_btn2');
                                    this.$rootScope.fromOptimumIdPage = false;

                                } else if(this.fromPaperlessPage){
                                    this.focus('navigation_btn1');
                                    this.$rootScope.fromPaperlessBillingPage = false;
                                }
                                // else if(this.fromVideoBillPage){
                                //     this.focus('navigation_btn1');
                                //     this.$rootScope.fromVideoBillPage = false;
                                // }
                                else if(this.fromTutorialPage){
                                  this.focus('navigation_btn3');
                                  this.$rootScope.fromTutorialPage = false;
                                } else if(this.fromFaqPage){
                                  this.focus('navigation_btn4');
                                  this.$rootScope.fromFaqPage = false;
                                } else {
                                    this.focus('navigation_btn0');
                                }
                                //this.focus('navigation_btn0');
                            }
                        });
                    }
                }
                else {
                    if (storage.getItem('session', 'accno')) {
                        accNum = storage.getItem('session', 'accno');
                        accNum = accNum.slice(0, 5) + "-" + accNum.slice(5, 11) + "-" + accNum.slice(11, 13);
                        this.account_number = accNum;
                    }
                    billingService.getCurrectAcc().then((resp) => {
                        console.log("resp of current account on landing page.:", resp);
                        if (resp && resp.email && resp.isPaperBill === "false") {
                            this.menuitems[1].label = "Paperless Billing";
                            $scope.paperlessbill = true;
                            console.log('!! omniture setting paperless true from another billing service call 5!!');
                        }
                    });

                    this.landingPageLoader = false;
                    if(this.fromOptIdsPage){
                        this.focus('navigation_btn2');
                        this.$rootScope.fromOptimumIdPage = false;

                    } else if(this.fromPaperlessPage){
                        this.focus('navigation_btn1');
                        this.$rootScope.fromPaperlessBillingPage = false;
                    }
                    // else if(this.fromVideoBillPage){
                    //     this.focus('navigation_btn1');
                    //     this.$rootScope.fromVideoBillPage = false;
                    // }
                    else if(this.fromTutorialPage){
                      this.focus('navigation_btn3');
                      this.$rootScope.fromTutorialPage = false;
                    } else if(this.fromFaqPage){
                      this.focus('navigation_btn4');
                      this.$rootScope.fromFaqPage = false;
                    } else {
                        this.focus('navigation_btn0');
                    }
                    //this.focus('navigation_btn0');
                }
            }, () => {
                this.landingPageLoader = false;
                if(this.fromOptIdsPage){
                    this.focus('navigation_btn2');
                    this.$rootScope.fromOptimumIdPage = false;
                }
                // else if(this.fromVideoBillPage){
                //     this.focus('navigation_btn2');
                //     this.$rootScope.fromVideoBillPage = false;
                // }
                else if(this.fromPaperlessPage){
                  this.focus('navigation_btn1');
                  this.$rootScope.fromPaperlessBillingPage = false;
                } else if(this.fromTutorialPage){
                  this.focus('navigation_btn3');
                  this.$rootScope.fromTutorialPage = false;
                } else if(this.fromFaqPage){
                  this.focus('navigation_btn4');
                  this.$rootScope.fromFaqPage = false;
                } else {
                  this.focus('navigation_btn0');
                }

                if (storage.getItem('session', 'casn')) {
                  var casnNum, casnNum1, i, tempVar="", j;
                  casnNum = storage.getItem('session', 'casn');
                  casnNum1 = storage.getItem('session', 'casn');
                  console.log("Casn 1 is:", casnNum1.length);
                  for(i=0; i<casnNum1.length; i++) {
                    j = i+2;
                    if(i === casnNum1.length-2 || i === casnNum1.length-1) {
                      tempVar = tempVar + casnNum1.slice(i,j);
                    } else {
                      tempVar = tempVar + casnNum1.slice(i,j) + ":";
                    }
                    i = i+1;
                  }
                  casnNum1 = tempVar;
                  this.serial_number = casnNum1;
                  console.log("this.serial_number:", this.serial_number);
                }
                console.log('Something wrong with all call and bpglobal fail.');
            });
        }
        else if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 2) {
          //suddenlink customer
            this.isSuddenlink = true;
            this.$rootScope.isSuddenlink = this.isSuddenlink;
            if(storage.getItem('session', 'showFaqTutorials') && storage.getItem('session', 'showFaqTutorials') === "1") {
              this.menuitems = [{
                  label: 'Usernames',
                  state: 'home.landingpage.suddenlinkidslanding'
              }, {
                  label: 'Tutorials',
                  state: 'home.landingpage.tutorialslanding'
              }, {
                  label: 'Quick Tips',
                  state: 'home.landingpage.faqlanding'
              }];
            } else {
              this.viewpaybillPage = true;
              this.fromFaqPage = false;
              this.fromTutorialPage = false;
              this.menuitems = [{
                  label: 'Usernames',
                  state: 'home.landingpage.suddenlinkidslanding'
              }];
            }

            console.log("menu items SuddenLink:", this.menuitems);

          laboxSSapi.getAllSuddenlinkIds().then((res) => {
            if(res && res.data && res.data.accountSummaryResponse.statusDescription && res.data.accountSummaryResponse.statusDescription == "Success"){
              this.unregUser = res.data.accountSummaryResponse.users[0].userName.search("unreg:") + 1;
              console.log('this.unregUser is ' +this.unregUser);
              if (this.unregUser === 1) {
                this.hasSuddenlinkId = false;
              } else {
                this.hasSuddenlinkId = true;
              }
              if (storage.getItem('session', 'sdl_acc_no') && storage.getItem('session', 'sdl_acc_no') != null) {
                this.AccountArray = storage.getItem('session', 'sdl_acc_no');
              } else {
                if (res.data.accountSummaryResponse.statementAccountNumbers != null) {
                  storage.setItem('session', 'sdl_acc_no', res.data.accountSummaryResponse.statementAccountNumbers);
                }
                this.AccountArray = res.data.accountSummaryResponse.statementAccountNumbers;
              }
              this.oldaccount_number = Math.min.apply( Math, this.AccountArray);
              console.log('this.oldaccount_number ' + this.oldaccount_number.toString());
              console.log('this.oldaccount_number.length ' + this.oldaccount_number.toString().length);
              this.new_account_number = this.oldaccount_number.toString();
              while (this.new_account_number.length < 16) {
                console.log('in while loop');
                this.new_account_number = "0" + this.new_account_number;
              }
              this.sdl_account_number = this.new_account_number.slice(0, 3) + "-" + this.new_account_number.slice(3, 7) + "-" + this.new_account_number.slice(7, 16);
              console.log('this.AccountArray is ' + this.sdl_account_number);
            } else {
              console.log('there is no account number');
            }
          });

            this.landingPageLoader = false;
            if(this.fromTutorialPage){
                this.focus('suddenlink-navigation_btn1');
                this.$rootScope.fromTutorialPage = false;
            } else if(this.fromFaqPage){
              this.focus('suddenlink-navigation_btn2');
              this.$rootScope.fromFaqPage = false;
            } else if(this.fromSdlIdsPage){
              this.focus('suddenlink-navigation_btn2');
              this.$rootScope.fromSdlIdsPage = false;
            } else {
                this.focus('suddenlink-navigation_btn0');
            }
            if (storage.getItem('session', 'casn')) {
              var casnNum, casnNum1, i, tempVar="", j;
              casnNum = storage.getItem('session', 'casn');
              casnNum1 = storage.getItem('session', 'casn');
              console.log("Casn 1 is:", casnNum1.length);
              for(i=0; i<casnNum1.length; i++) {
                j = i+2;
                if(i === casnNum1.length-2 || i === casnNum1.length-1) {
                  tempVar = tempVar + casnNum1.slice(i,j);
                } else {
                  tempVar = tempVar + casnNum1.slice(i,j) + ":";
                }
                i = i+1;
              }
              casnNum1 = tempVar;
              this.serial_number = casnNum1;
              console.log("this.serial_number:", this.serial_number);
            }
            // this.focus('suddenlink-navigation_btn0');
        } else {
            // alert('customer is neither from cable-vision nor from sudden-link.');
            if (storage.getItem('session', 'casn')) {
              var casnNum, casnNum1, i, tempVar="", j;
              casnNum = storage.getItem('session', 'casn');
              casnNum1 = storage.getItem('session', 'casn');
              console.log("Casn 1 is:", casnNum1.length);
              for(i=0; i<casnNum1.length; i++) {
                j = i+2;
                if(i === casnNum1.length-2 || i === casnNum1.length-1) {
                  tempVar = tempVar + casnNum1.slice(i,j);
                } else {
                  tempVar = tempVar + casnNum1.slice(i,j) + ":";
                }
                i = i+1;
              }
              casnNum1 = tempVar;
              this.serial_number = casnNum1;
              console.log("this.serial_number:", this.serial_number);
            } else {
              console.log('no casn');
            }
            if (storage.getItem('session','home_id')) {
              var cidx = storage.getItem('session','home_id');
              this.cidx = cidx;
            } else {
              console.log('no home id');
            }
            this.displayGenericAlertModal = true;
            this.genericAlertMsg = 'There is no plant_id option, casn = ' + this.serial_number + ' the home id is = ' + this.cidx;
            this.focusItem('cancel-btn');

        }
    }



    //this.account_number=storage.getItem('session', 'accno');//

    this.goPayBill=function(){
      // omniture deauth pay now event
      console.log('!!omniture deauth pay Now');
      console.log('billing status : ' +$scope.billingStatus);
      if($scope.popup) {
        console.log('!!omniture pay now after popup');
        analyticsService.sendReport('home', $scope.pageName, 'event2', null, null, null, 'Pay Now',
        this.$rootScope.analytics.omniturePath +'/viewpaybill', $scope.billingStatus, $scope.paperlessbill,
        this.$rootScope.analytics.omniturePath +'/landingpage');
      } else {
        console.log('!!omniture pay now from landingpage');
        analyticsService.sendReport('home', $scope.pageName, 'event2', null, null, null, 'Pay Now',
        this.$rootScope.analytics.omniturePath +'/viewpaybill', $scope.billingStatus, $scope.paperlessbillsl,
        this.$rootScope.analytics.omniturePath +'/landingpage/viewpaybilllanding');
      }

      $scope.popup = false;
      this.displayAlertModal = false;

      this.state.go('home.viewpaybill');
    };

    this.cancel=function(){
      // omniture deauth pay later event
      console.log('!!omniture deauth pay later');
      analyticsService.sendReport('home', $scope.pageName, null, null, null, null, 'Pay Later',
        this.$rootScope.analytics.omniturePath +'/landingpage/viewpaybilllanding', $scope.billingStatus, $scope.paperlessbill,
        this.$rootScope.analytics.omniturePath +'/landingpage');

      console.log('!!omniture landing page tag after deauth pay later');
      analyticsService.sendReport('home', 'my account', 'event1', null, null, null, null, null, $scope.billingStatus,
        $scope.paperlessbill, this.$rootScope.analytics.omniturePath +'/landingpage/viewpaybilllanding');

      this.displayAlertModal = false;
      this.focusItem('navigation_btn0');
    };
    this.cancelGenericAlert=function(){
      this.displayGenericAlertModal = false;
      this.focusItem('navigation_btn0');
    };
    this.itemClickHandler = event => {
        //console.log("Event:", event);
        if (event.item.label === "View & Pay My Bill") {
          //omniture when click view & pay my bill from landingpage
          console.log('!!omniture when click view & pay my bill from landingpage');
          analyticsService.sendReport('home', 'my account', 'event2', null, null, null, 'view & pay my bill',
            this.$rootScope.analytics.omniturePath +'/viewpaybill', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill,
            this.$rootScope.analytics.omniturePath +'/landingpage/viewpaybilllanding');

          this.state.go('home.viewpaybill');
        } else if (event.item.label === "Understanding My Bill"){
          // if(skylink != null){
          //         this.$rootScope.fromLandingPage = true;
          //         this.$rootScope.title = "My Bill Explained";
          //         this.state.go('videoplayer', {
          //           back: true,
          //           url: skylink
          //           });
          //       } else {
          //         console.log('error fetching video bill');
          //       }
          if ((storage.getItem('session','home_id') == "36063655") || ((storage.getItem('session','home_id') == "36071973"))) {
            console.log('specific case where it should polay the default video and get no api response');
            this.$rootScope.fromLandingPage = true;
            this.$rootScope.title = "My Bill Explained";
            this.state.go('videoplayer', {
                    back: true,
                    url: "https://player.sundaysky.com/customers/optimum/optimum_fallback.mp4"
                    });
          } else {
            laboxSSapi.getVideoBill().then((res)=>{
                console.log('calling video bill api');
                if(res && res.data._links){
                    this.working_link = res.data._links['video-stream'][0].href;
                    console.log('res.data["_links"]["video-stream"].href is ' + res.data._links['video-stream'][0].href);
                    console.log('working link is ' + this.working_link);
                    if (this.working_link != null && storage.getItem('session','home_id') != "40520101") {
                      console.log('res.data is ' + res.data);
                      console.log('res.data["_links"]["video-stream"].href is ' + res.data._links['video-stream'][0].href);
                      this.$rootScope.fromLandingPage = true;
                          this.$rootScope.title = this.working_link;
                          this.state.go('player', {
                            back: true,
                            url: this.working_link
                            });
                    } else {
                      console.log('response from video bill but has no link');
                      this.$rootScope.fromLandingPage = true;
                        this.$rootScope.title = "My Bill Explained";
                        this.state.go('videoplayer', {
                          back: true,
                          url: res.data.fallback.video.href
                          });
                    }
                } else {
                  console.log('no response from videobill');
                  console.log('res.data is ' + res.data);
                  this.$rootScope.fromLandingPage = true;
                  this.$rootScope.title = "My Bill Explained";
                  this.state.go('videoplayer', {
                    back: true,
                    url: "https://player.sundaysky.com/customers/optimum/optimum_fallback.mp4"
                    });
                }
            });
          }

        }else if(event.item.label === "Go Paperless"){
          // omniture when click paperlessbilling from landingpage
          console.log('!!omniture when click paperlessbilling from landingpage!!');
          analyticsService.sendReport('home', 'paperless billing', null, null, null, null, 'Go Paperless', this.$rootScope.analytics.omniturePath +'/paperlessbilling',
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/landingpage/paperlessbillinglanding');

          if(storage.getItem('session', 'hasOptimumId')){
            this.state.go('home.paperlessbilling');
          }
        }else if(event.item.label === "Optimum IDs"){
          // omniture when click ids from landingpage
          console.log('!!omniture when click ids from landingpage!!');
          analyticsService.sendReport('home', 'ids', null, null, null, null, 'IDs', this.$rootScope.analytics.omniturePath +'/optimumids',
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/landingpage/optimumidslanding');

          if(storage.getItem('session', 'hasOptimumId')){
            this.state.go('home.optimumids');
          }
        }else if(event.item.label === "Usernames"){
          console.log('this.hasSuddenlinkId is ' + this.hasSuddenlinkId);
          if(this.hasSuddenlinkId === true){
            this.state.go('home.suddenlinkids');
          }
        }else if(event.item.label === "Tutorials"){
          // omniture when click tutorials from landingpage
          console.log('!!omniture when click tutorials from landingpage!!');
          analyticsService.sendReport('home', 'tutorial', null, null, null, null, 'Tutorials', this.$rootScope.analytics.omniturePath +'/tutorials',
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/landingpage/tutorialslanding');
          this.state.go('home.tutorials');
        }else if(event.item.label === "Quick Tips"){
          // omniture when click faq from landingpage
          console.log('!!omniture when click faq from landingpage!!');
          analyticsService.sendReport('home', 'quick tips', null, null, null, null, 'Quick Tips', this.$rootScope.analytics.omniturePath +'/faq',
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/landingpage/faqlanding');
            this.state.go('home.faq');
        }else {
          //this.state.go('home.keyboard');
          console.log("");
        }
    };

    this.nextComponentHandler = index => {
    };

    this.prevComponentHandler = event => {
    };

  }


  /*$postLink() {
    //this.focus('navigation_btn0');
  }

  focus(fromState) {
      var ix;

      if (fromState) {
          this.items.forEach((item, _ix) => {
              if (item.state === fromState) {
                  ix = _ix;
                  return 0;
              }
          });
      }

      this.$scope.$broadcast('focus', {
          id: 'navigation',
          index: ix
      });
  }*/

  focus(id){
    console.log("id in focus:", id);
    setTimeout(function() {
      document.getElementById(id).focus();
    }, 150);
  }

  focusItem(id) {
    const el = document.getElementById(id);
    if (el) {
      el.focus();
    } else {
      this.$timeout(this.focusItem.bind(this,id));
     }
  }

}
LandingpageController.$inject = ['$state', '$window','storage','billingService', '$rootScope','$filter','$timeout','navigationManager','$scope', 'laboxSSapi', 'analyticsService'];
export default LandingpageController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/landingpage.controller.js